/**
 * メニューAPI クライアント
 */

import { authFetch, API_BASE_URL } from "./client";

/**
 * メニューレスポンスの型
 */
export interface MenuResponse {
    id: number;
    tenant_id: string;
    code: string;
    platform: string;
    type: string;
    parent_id: number | null;
    name: string;
    name_formula: string | null;
    url: string | null;
    icon: string | null;
    display_order: number;
    min_role_view: number;
    min_role_edit: number;
    is_display: number;
    description: string | null;
    created_at: string | null;
    updated_at: string | null;
}

/**
 * メニュー一覧レスポンスの型
 */
export interface MenuListResponse {
    items: MenuResponse[];
    total: number;
}

/**
 * メニュー一覧を取得
 */
export async function fetchMenus(params?: {
    platform?: string;
    type?: string;
    parent_id?: number;
}, signal?: AbortSignal): Promise<MenuListResponse> {
    const searchParams = new URLSearchParams();

    if (params?.platform) {
        searchParams.set("platform", params.platform);
    }
    if (params?.type) {
        searchParams.set("type", params.type);
    }
    if (params?.parent_id !== undefined) {
        searchParams.set("parent_id", String(params.parent_id));
    }

    const queryString = searchParams.toString();
    const url = `${API_BASE_URL}/menus${queryString ? `?${queryString}` : ""}`;

    const response = await authFetch(url, { signal });
    if (!response.ok) {
        throw new Error(`メニュー一覧の取得に失敗しました: ${response.status}`);
    }
    return response.json();
}
